import { ReasonCategoryEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric,Matches, IsNotEmpty, IsOptional, MaxLength } from "class-validator";


export class ReasonsDTO {
    @ApiProperty()
    @IsNotEmpty({message:"ReasonId should not be empty"})
    @IsAlphanumeric()
    reasonId?: number;

    @ApiProperty()
    @IsNotEmpty({message:"reasonsCode should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    reasonCode: string;

    @ApiProperty()
    @IsNotEmpty({message:"reasonsName should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    reasonName: string;

    @ApiProperty()
    isActive: boolean;

    createdAt : Date;

   @ApiProperty()
   @IsOptional()
   @MaxLength(50,{message:"Created User allows maximum 50 characters"}) 
   @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })  
   createdUser :string ;

   updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(50, { message: "Updated User allows maximum 50 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;
  

  @ApiProperty()
  versionFlag : number;

  @ApiProperty()
  reasonCategory: ReasonCategoryEnum;
}

